import React, { useState,useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { Game, Loading } from '../../components'
import { useAxios } from '../../hooks'
import { url } from '../../constants'
import { platform_data } from '../../gameData'
import { getRecentMonthDateString, getRecentYearDateString } from '../../utils'
import './Result.css'

const Result = ({ category }) => {
  // console.log('category', category)
  const [title, setTitle] = useState('')
  const [queryUrl, setQueryUrl] = useState('')
  const [queryParams, setQueryParams] = useState('')

  let { platform } = useParams();
  let [searchParams] = useSearchParams();
  let searchTerm = searchParams.get('q')

  const getPlatformName = (id) => {
    let name = ''
    platform_data.forEach(data => {
      if(data.id === parseInt(id)) {
        name = data.name 
      } 
    })
    return name
  }

  useEffect(() => {
    // console.log('uef category')
    switch (category) {
      case 'popular':
        setTitle('Most Popular (All-time)')
        break;
      case 'recent':
        setTitle('Games released in the last month')
        setQueryParams('&dates=' + getRecentMonthDateString());
        break;
      case 'best':
        setTitle('Highest user-rated games of all-time')
        setQueryParams('&ordering=-rating');
        break;
      case 'platform':
        setTitle(`Recent games on ${getPlatformName(platform)}`)
        setQueryParams(`&parent_platforms=${platform}&dates=${getRecentYearDateString()}`)
        break;
      case 'search':
        setTitle('Search Results')
        setQueryParams(`&search=${searchTerm}`)
        break;
      default:
        break;
    }
  }, [category, platform, searchTerm]);

  useEffect(() => {
    // console.log('queryParams', queryParams)
    let gameDataUrl = url.GAMES_API_URL + '?' + url.API_KEY_PARAM + queryParams
    setQueryUrl(gameDataUrl)
  }, [queryParams]);

  return (
    <div className='result'>
      <ResultPanel title={title} queryUrl={queryUrl} setQueryUrl={setQueryUrl } />    
    </div>
    
  )
}
const Pagination = ({ totalPages, currentPage, changePage }) => {
  let pagesToShow = new Array(5)
  
  if(currentPage - 2 <= 0) {
    pagesToShow = [1, 2, 3, 4, 5]
  }
  else if (currentPage + 2 > totalPages) {
    pagesToShow = [totalPages-4, totalPages-3, totalPages-2, totalPages-1, totalPages]
  }
  else {
    pagesToShow = [currentPage-2, currentPage-1, currentPage, currentPage+1, currentPage+2]
  }
  pagesToShow.map(page => {
    return(
      <li className={page === currentPage && 'active'} key={page}><button onClick={()=>{changePage(page)}} aria-current="page"><span className="visuallyhidden">page </span>{page}</button></li>
    )
  })
  return (
    <>
      <nav aria-label="pagination">
        <ul className="pagination">
            <li><button onClick={()=>{changePage('previous')}} ><span aria-hidden="true">&laquo;</span><span className="visuallyhidden">previous set of pages</span></button></li>
            {pagesToShow.map(page => {
              return(
                <li className={page === currentPage ? 'active' : ''} key={page}><button onClick={()=>{changePage(page)}} aria-current="page"><span className="visuallyhidden">page </span>{page}</button></li>
              )
            })}
            <li><button onClick={()=>{changePage('next')}}><span className="visuallyhidden">next set of pages</span><span aria-hidden="true">&raquo;</span></button></li>
        </ul>
      </nav>
    </>
  )
}
const ResultPanel = ({title, queryUrl, setQueryUrl}) => {
  const [pageData, setPageData] = useState(
    {
      total: 0,
      current: 0,
      previous: '',
      next: ''
    }
  )
  const [gameData, setGameData] = useState(null);
  const { data, error, isLoading } = useAxios(queryUrl)

  useEffect(() => {
    let currPage = 0
    if(queryUrl) {
      let url = new URL(queryUrl)
      currPage = url.searchParams.get('page') || 1
      currPage = Number(currPage)
      // console.log('currPage', currPage, typeof(currPage))
    }
    setPageData({
      total: Math.ceil(data.count / 20),
      current: currPage,
      previous: data.previous,
      next: data.next
    })
    setGameData(data.results)
    // eslint-disable-next-line
  }, [data])

  const changePage = (page) => {
    console.log('Page change, param : ', page, typeof(page))
    if(typeof page === 'number') {
      let url = new URL(queryUrl)
      url.searchParams.set('page', page)
      setQueryUrl(url.toString())
    }
    switch(page){
      case 'next':
        if(!pageData.next) {
          break
        }
        setQueryUrl(pageData.next)
        break
      case 'previous':
        if(!pageData.previous) break
        setQueryUrl(pageData.previous)
        break
      default:
        break
    }
  }

  return (
    <>
      <h1>{title}</h1>
      <div className='game__container'>
      {isLoading && <Loading />}
      {error && <p>{error}</p>}
      {!isLoading && !error && gameData &&
        gameData.map(game =>{
          return (
            <Game key={game.id} data={game}/>
          )
        } )}
      </div>
      <div>
      {!isLoading && !error && gameData &&
      <Pagination totalPages={pageData.total} currentPage={pageData.current} changePage={changePage}/>}
      </div>
    </>
  )
}

export default Result